import { useTeamQuery, Team } from "@/features/teams/graphql/generated";

export const useTeamDetails = (teamId?: number) => {
  const { data, loading, error } = useTeamQuery({
    variables: {
      id: teamId!,
    },
    skip: !teamId,
  });

  const team = data?.team || ({} as Team);

  return { team, loading, error };
};
